import React, { useRef } from "react";
import { Button, Form, Modal, notification } from "antd";
import { FiArrowLeft, FiCopy } from "react-icons/fi";
import dayjs from "dayjs";

const ModalPromptLog = ({ contentItem, openModal, onClose = () => {} }) => {
	const fieldRef = useRef();

	const handleCopyClipboard = () => {
		const text = fieldRef.current.textContent;

		navigator.clipboard
			.writeText(text)
			.then(() => {
				notification.success({ message: "Copied!" });
			})
			.catch((err) => {
				notification.error({
					message: "Failed to copy text to clipboard!",
				});
				console.error("Failed to copy text to clipboard: ", err);
			});
	};

	return (
		<Modal
			footer={null}
			className="profile-modal"
			open={openModal}
			onCancel={() =>
				onClose({
					adminPromptShow: true,
					historyPromptShow: false,
				})
			}
			destroyOnClose
		>
			<div className="top-section">
				<div className="user-profile">
					<Button
						className="user-profile-icon"
						icon={<FiArrowLeft size={24} />}
						onClick={() =>
							onClose({
								adminPromptShow: true,
								historyPromptShow: false,
							})
						}
					/>
					Prompt context Log
				</div>
				<div
					className="user-profile-wrapper"
					style={{ width: "100%", marginBottom: 24 }}
				>
					<span>Prompt context</span>
					<Button
						type="default"
						className="ant-btn-copy"
						icon={<FiCopy />}
						onClick={handleCopyClipboard}
					>
						Copy
					</Button>
				</div>
				<Form>
					<Form.Item>
						<div className="prompt-wrapper" ref={fieldRef}>
							{contentItem.prompt}
						</div>
						<small
							style={{
								display: "block",
								width: "100%",
								textAlign: "right",
							}}
						>
							By {contentItem.updatedBy} @{" "}
							{dayjs(contentItem.updatedDate).format(
								"HH:mm A - DD MMM, YYYY"
							)}
						</small>
					</Form.Item>
				</Form>
			</div>
		</Modal>
	);
};

export default ModalPromptLog;
